/**
 * Scroll-triggered Animations
 * Adds entrance animations when elements come into viewport
 */

class ScrollAnimations {
    constructor() {
        this.animatedElements = [];
        this.init();
    }
    
    init() {
        // Add data attributes to animatable elements
        this.setupAnimations();
        
        // Create intersection observer
        this.createObserver();
        
        // Start observing elements
        this.observeElements();
    }
    
    setupAnimations() {
        // Add animation classes to elements
        const selectors = {
            '.feature-card': 'fade-up',
            '.stat-item': 'fade-up',
            '.process-step': 'fade-up',
            '.testimonial-card': 'fade-up',
            '.cta-section': 'fade-in',
            'h1:not(.hero-title)': 'fade-right',
            'h2:not(.hero-title)': 'fade-right',
            '.card': 'fade-up',
            'p:not(.hero-text)': 'fade-in'
        };
        
        Object.entries(selectors).forEach(([selector, animation]) => {
            document.querySelectorAll(selector).forEach(el => {
                if (!el.classList.contains('no-animate')) {
                    el.setAttribute('data-animation', animation);
                    el.classList.add('scroll-animate');
                    this.animatedElements.push(el);
                }
            });
        });
    }
    
    createObserver() {
        const options = {
            threshold: 0.1,
            rootMargin: '0px 0px -10% 0px'
        };
        
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.animateElement(entry.target);
                }
            });
        }, options);
    }
    
    observeElements() {
        this.animatedElements.forEach(el => {
            this.observer.observe(el);
        });
    }
    
    animateElement(element) {
        const animation = element.getAttribute('data-animation');
        const delay = element.getAttribute('data-delay') || 0;
        
        setTimeout(() => {
            element.classList.add('animated', animation);
            element.classList.remove('scroll-animate');
            
            // Stop observing once animated
            this.observer.unobserve(element);
        }, delay);
    }
    
    // Method to manually trigger animation
    triggerAnimation(element) {
        if (element && element.getAttribute('data-animation')) {
            this.animateElement(element);
        }
    }
    
    // Reset animations (useful for page transitions)
    reset() {
        this.animatedElements.forEach(el => {
            el.classList.remove('animated', el.getAttribute('data-animation'));
            el.classList.add('scroll-animate');
            this.observer.observe(el);
        });
    }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    // Check if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (!prefersReducedMotion) {
        window.scrollAnimations = new ScrollAnimations();
    }
});

export default ScrollAnimations;